// @ts-nocheck
/* global fbq */
import Api from "@services/api";

function getEventCurrency(userData) {
  return String(userData?.currency || userData?.plan?.currency || 'BRL').toUpperCase();
}

const pixel = {
  // Constantes de eventos padronizados
  events: {
    page_view: 'page_view',
    signup_complete: 'signup_complete',
    initiate_checkout: 'initiate_checkout',
    purchase: 'purchase',
  },

  // Armazena os providers instalados
  _installed: [],

  // Armazena dados do usuário para envio nos eventos
  _userData: null,

  /**
   * Define dados do usuário para envio nos eventos
   * @param {Object} userData - Dados do usuário (email, nome, phone, cpf, etc.)
   * @param {Object} orderData - Dados da compra (value, currency, plan, etc.)
   */
  setUserData(userData = {}, orderData = {}) {
    this._userData = {
      ...userData,
      ...orderData,
      timestamp: new Date().toISOString(),
      url: window.location.href,
      referrer: document.referrer,
      userAgent: navigator.userAgent,
      language: navigator.language,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      screen: {
        width: window.screen.width,
        height: window.screen.height,
      },
      viewport: {
        width: window.innerWidth,
        height: window.innerHeight,
      }
    };
  },

  /**
   * Coleta dados de IP e parâmetros da URL
   * @returns {Object} Dados coletados
   */
  _collectAdditionalData() {
    const urlParams = new URLSearchParams(window.location.search);
    const params = {};

    for (const [key, value] of urlParams.entries()) {
      params[key] = value;
    }

    return {
      urlParams: params,
      deviceId: _getDeviceId(),
      timestamp: new Date().toISOString(),
      sessionId: this._getSessionId()
    };
  },

  /**
   * Gera ou recupera ID da sessão
   */
  _getSessionId() {
    let sessionId = sessionStorage.getItem('pixel_session_id');
    if (!sessionId) {
      sessionId = Date.now().toString(36) + Math.random().toString(36).substr(2);
      sessionStorage.setItem('pixel_session_id', sessionId);
    }
    return sessionId;
  },

  facebook: {
    install(pixelId) {
      if (window.fbq) return;

      (function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod
            ? n.callMethod.apply(n, arguments)
            : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = !0;
        n.version = '2.0';
        n.queue = [];
        t = b.createElement(e);
        t.async = !0;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

      fbq('init', pixelId);
    },

    track(event, pixelId, userData = null) {
      console.log('Should track FB', event, userData);

      const parameters = this._buildFacebookParameters(event, userData);

      if (parameters) {
        fbq('track', event, parameters);
      } else {
        fbq('track', event);
      }
    },

    _buildFacebookParameters(event, userData) {
      if (!userData) return null;

      const baseParams = {
        currency: getEventCurrency(userData),
        source: 'website'
      };

      // Parâmetros específicos por evento
      switch (event) {
        case 'PageView':
          return {
            ...baseParams,
            content_name: userData.plan?.name || 'Checkout',
            content_category: 'subscription'
          };

        case 'InitiateCheckout':
          return {
            ...baseParams,
            value: userData.value || 0,
            content_name: userData.plan?.name || 'Subscription',
            content_ids: [userData.plan?.id?.toString() || ''],
            content_type: 'subscription',
            num_items: 1
          };

        case 'Purchase':
          return {
            ...baseParams,
            value: userData.value || 0,
            content_name: userData.plan?.name || 'Subscription',
            content_ids: [userData.plan?.id?.toString() || ''],
            content_type: 'subscription',
            num_items: 1,
            order_id: userData.orderId || userData.transactionId || Date.now().toString()
          };

        case 'CompleteRegistration':
          return {
            ...baseParams,
            content_name: 'User Registration',
            content_category: 'signup'
          };

        default:
          return baseParams;
      }
    },

    mapEvent(event) {
      const eventMap = {
        [pixel.events.page_view]: 'PageView',
        [pixel.events.signup_complete]: 'CompleteRegistration',
        [pixel.events.initiate_checkout]: 'InitiateCheckout',
        [pixel.events.purchase]: 'Purchase',
      };
      return eventMap[event];
    }
  },

  google_analytics: {
    install(trackingId) {
      // Verifica se já foi instalado (tanto GA4 quanto UA)
      if (window.gtag) return;

      // Inicializa o dataLayer para o gtag
      window.dataLayer = window.dataLayer || [];
      window.gtag = function () {
        window.dataLayer.push(arguments);
      };
      window.gtag('js', new Date());

      // Carrega o script do GA4
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${trackingId}`;
      document.head.appendChild(script);

      // Configura o tracking ID
      window.gtag('config', trackingId, {
        send_page_view: false // Vamos controlar manualmente os page views
      });
    },

    track(event, trackingId, userData = null) {
      if (!window.gtag) {
        console.warn('Google Analytics não foi inicializado');
        return;
      }

      const mappedEvent = this._getGA4EventName(event);
      const parameters = this._buildGA4Parameters(event, userData);

      console.log('GA4 tracking:', mappedEvent, parameters);

      window.gtag('event', mappedEvent, parameters);
    },

    _getGA4EventName(event) {
      // Mapeia para nomes de eventos padrão do GA4
      const eventNameMap = {
        'PageView': 'page_view',
        'InitiateCheckout': 'begin_checkout',
        'Purchase': 'purchase',
        'SignupComplete': 'sign_up'
      };
      return eventNameMap[event] || event.toLowerCase();
    },

    _buildGA4Parameters(event, userData) {
      const baseParams = {
        currency: getEventCurrency(userData),
        page_location: window.location.href,
        page_title: document.title
      };

      if (!userData) return baseParams;

      switch (event) {
        case 'PageView':
          return {
            ...baseParams,
            page_title: userData.plan?.name || document.title,
            content_group: 'checkout'
          };

        case 'InitiateCheckout':
          return {
            ...baseParams,
            value: userData.value || 0,
            items: [{
              item_id: userData.plan?.id?.toString() || '',
              item_name: userData.plan?.name || 'Subscription',
              item_category: 'subscription',
              price: userData.value || 0,
              quantity: 1
            }]
          };

        case 'Purchase':
          return {
            ...baseParams,
            transaction_id: userData.orderId || userData.transactionId || Date.now().toString(),
            value: userData.value || 0,
            items: [{
              item_id: userData.plan?.id?.toString() || '',
              item_name: userData.plan?.name || 'Subscription',
              item_category: 'subscription',
              price: userData.value || 0,
              quantity: 1
            }]
          };

        case 'SignupComplete':
          return {
            ...baseParams,
            method: 'email'
          };

        default:
          return {
            ...baseParams,
            event_category: 'Ecommerce',
            event_label: userData.plan?.name || 'Subscription'
          };
      }
    },

    mapEvent(event) {
      const eventMap = {
        [pixel.events.page_view]: 'PageView',
        [pixel.events.signup_complete]: 'SignupComplete',
        [pixel.events.initiate_checkout]: 'InitiateCheckout',
        [pixel.events.purchase]: 'Purchase',
      };
      return eventMap[event];
    }
  },

  google_tag_manager: {
    install(containerId) {
      if (window.dataLayer) return;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js'
      });

      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtm.js?id=${containerId}`;
      document.head.appendChild(script);
    },

    track(event, containerId, userData = null) {
      window.dataLayer = window.dataLayer || [];

      const eventData = this._buildGTMParameters(event, userData);
      window.dataLayer.push(eventData);
    },

    _buildGTMParameters(event, userData) {
      const baseEvent = {
        event: event,
        timestamp: new Date().toISOString(),
        page_url: window.location.href,
        page_title: document.title,
        user_agent: navigator.userAgent,
        language: navigator.language
      };

      if (!userData) return baseEvent;

      // Adicionar dados do usuário
      if (userData.email) baseEvent.user_email = userData.email;
      if (userData.name) baseEvent.user_name = userData.name;
      if (userData.phone) baseEvent.user_phone = userData.phone;
      if (userData.cpf) baseEvent.user_cpf = userData.cpf;

      // Adicionar dados específicos do evento
      switch (event) {
        case 'initiate_checkout':
          return {
            ...baseEvent,
            event_category: 'Ecommerce',
            event_action: 'InitiateCheckout',
            value: userData.value || 0,
            currency: getEventCurrency(userData),
            items: [{
              item_id: userData.plan?.id?.toString() || '',
              item_name: userData.plan?.name || 'Subscription',
              item_category: 'Subscription',
              price: userData.value || 0,
              quantity: 1
            }]
          };

        case 'purchase':
          return {
            ...baseEvent,
            event_category: 'Ecommerce',
            event_action: 'Purchase',
            transaction_id: userData.orderId || userData.transactionId || Date.now().toString(),
            value: userData.value || 0,
            currency: getEventCurrency(userData),
            items: [{
              item_id: userData.plan?.id?.toString() || '',
              item_name: userData.plan?.name || 'Subscription',
              item_category: 'Subscription',
              price: userData.value || 0,
              quantity: 1
            }]
          };

        case 'signup_complete':
          return {
            ...baseEvent,
            event_category: 'User',
            event_action: 'SignupComplete',
            method: 'Email'
          };

        case 'page_view':
          return {
            ...baseEvent,
            event_category: 'Page',
            event_action: 'PageView',
            content_name: userData.plan?.name || 'Checkout',
            content_category: 'Subscription'
          };

        default:
          return baseEvent;
      }
    },

    mapEvent(event) {
      const eventMap = {
        [pixel.events.page_view]: 'page_view',
        [pixel.events.signup_complete]: 'signup_complete',
        [pixel.events.initiate_checkout]: 'initiate_checkout',
        [pixel.events.purchase]: 'purchase',
      };
      return eventMap[event];
    }
  },

  hosted: {
    install(pixelId) {
      if (!pixelId) return;
    },

    track(name, id, userData = null) {
      try {
        setTimeout(() => {
          const endpoint = !window.signed ? '/pixel/event' : '/pixel/event/signed';

          const urlParams = new URLSearchParams(window.location.search);
          const params = {};

          for (const [key, value] of urlParams.entries()) {
            params[key] = value;
          }

          const payload = {
            name,
            pixel: id,
            device: _getDeviceId(),
            payload: {
              params,
              ...(userData && this._buildHostedParameters(userData))
            }
          };

          Api.post(endpoint, payload);
        }, 500)
      } catch (e) {
        console.error('Erro ao disparar evento para o pixel:', e);
      }
    },

    _buildHostedParameters(userData) {
      return {
        user_data: {
          email: userData.email || '',
          name: userData.name || '',
          phone: userData.phone || '',
          cpf: userData.cpf || ''
        },
        order_data: {
          value: userData.value || 0,
          currency: getEventCurrency(userData),
          plan_id: userData.plan?.id || '',
          plan_name: userData.plan?.name || '',
          order_id: userData.orderId || userData.transactionId || '',
          installments: userData.installments || 1
        },
        session_data: {
          timestamp: new Date().toISOString(),
          url: window.location.href,
          referrer: document.referrer,
          user_agent: navigator.userAgent,
          language: navigator.language,
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
        }
      };
    },

    mapEvent(event) {
      return event;
    }
  },

  /**
   * Instala os pixels fornecidos e armazena os providers ativos
   * @param {Array} pixels - Lista de pixels retornada da API
   */
  initialize(pixels) {
    this._installed = [];

    pixels.forEach((pixel) => {
      const providerId = pixel.provider.id;
      const pixelId = pixel.provider.pixel;

      const engine = this[providerId];
      if (engine && typeof engine.install === 'function') {
        engine.install(pixelId);
        this._installed.push(pixel);
      }
    });
  },

  /**
   * Dispara um evento para todos os pixels instalados
   * @param {string} eventName - Nome do evento genérico (deve vir de pixel.events)
   * @param {Object} additionalData - Dados adicionais para o evento (opcional)
   */
  dispatchEvent(eventName, additionalData = {}) {
    // Combinar dados do usuário com dados adicionais
    const userData = {
      ...this._userData,
      ...additionalData
    };

    this._installed?.forEach(({ id, provider }) => {
      try {
        const engine = this[provider.id];
        if (!engine) return;

        const mappedEvent = engine.mapEvent(eventName);
        if (mappedEvent) {
          engine.track(mappedEvent, id, userData);
        }
      } catch (error) {
        console.error('Erro ao disparar evento para o pixel:', error);
      }
    });
  }
};

export default pixel;



function _getDeviceId() {
  let deviceId = localStorage.getItem('pixel_device_id');

  if (!deviceId) {
    const components = [
      window.navigator.userAgent,
      window.navigator.language,
      window.screen.width,
      window.screen.height,
      window.screen.colorDepth,
      window.navigator.platform,
      window.navigator.hardwareConcurrency,
      window.navigator.deviceMemory,
      window.navigator.maxTouchPoints,
      window.navigator.vendor,
      new Date().getTime(),
      Math.random()
    ];

    // Create a longer hash using multiple rounds of hashing
    const hashString = components.join('|');

    // Function to create a hash from a string
    const createHash = (str, seed = 0) => {
      let h1 = 0xdeadbeef ^ seed;
      let h2 = 0x41c6ce57 ^ seed;

      for (let i = 0; i < str.length; i++) {
        const ch = str.charCodeAt(i);
        h1 = Math.imul(h1 ^ ch, 2654435761);
        h2 = Math.imul(h2 ^ ch, 1597334677);
      }

      h1 = Math.imul(h1 ^ (h1 >>> 16), 2246822507) ^ Math.imul(h2 ^ (h2 >>> 13), 3266489909);
      h2 = Math.imul(h2 ^ (h2 >>> 16), 2246822507) ^ Math.imul(h1 ^ (h1 >>> 13), 3266489909);

      return 4294967296 * (2097151 & h2) + (h1 >>> 0);
    };

    // Generate multiple hashes with different seeds
    const hashes = [
      createHash(hashString, 1),
      createHash(hashString, 2),
      createHash(hashString, 3),
      createHash(hashString, 4)
    ];

    // Combine hashes into a single string
    const combinedHash = hashes.map(h => h.toString(16).padStart(8, '0')).join('');

    // Convert to base64 and ensure 64 characters
    deviceId = btoa(combinedHash)
      .replace(/[+/=]/g, '') // Remove base64 special characters
      .slice(0, 64) // Ensure exactly 64 characters
      .padEnd(64, '0'); // Pad with zeros if shorter

    localStorage.setItem('pixel_device_id', deviceId);
  }

  return deviceId;

}
